export default __webpack_public_path__ + "static/media/mr_mrs_smith_xl2.d9bb83c7.png";